import { useEffect } from 'react'

import { useWhiteLabelStore } from '@/stores/white-label'

const DEFAULT_APP_NAME = 'Signater'

/**
 * Hook to update the page title.
 *
 * @param title - The page title (without the company name)
 *
 * @example
 * // In a page component:
 * usePageTitle('Dashboard')
 * // Result: "Dashboard | Signater" or "Dashboard | CompanyName" (white-label)
 *
 * @example
 * // Without title (only the company name):
 * usePageTitle()
 * // Result: "Signater" or "CompanyName" (white-label)
 */
export function usePageTitle(title?: string | null) {
  const companyName = useWhiteLabelStore((state) => state.companyName)
  const appName = companyName || DEFAULT_APP_NAME

  useEffect(() => {
    // null means "skip" — lets child layouts defer to PageTitleManager
    // when navigating away from their routes
    if (title === null) return

    if (title) {
      document.title = `${title} | ${appName}`
    } else {
      document.title = appName
    }
  }, [title, appName])
}
